import "@hotwired/turbo-rails"
import TurboPower from 'turbo_power'
import { StreamActions } from "@hotwired/turbo"
import "./controllers"

TurboPower.initialize(StreamActions)

StreamActions.open_modal = function() {
  const modal_id = this.getAttribute("modal_id")
  const modal = document.querySelector(modal_id)
  modal.classList.remove("hidden")
  modal.showModal()
}

StreamActions.upsert_modal = function() {
  const modal_id = this.getAttribute("modal_id")
  const modal_html = this.getAttribute("html")
  const modal = document.querySelector(modal_id)

  if(modal) {
    modal.remove()
  }

  document.body.insertAdjacentHTML("beforeend", modal_html);
}

StreamActions.close_modal = function() {
  document.querySelectorAll("dialog").forEach(dialog => {
    dialog.close()
  })
}

StreamActions.render_mermaid = function() {
  window.mermaid.run();
}

StreamActions.refresh_textarea = function() {
  const textareaEls = document.querySelectorAll(this.getAttribute("selector"))
  textareaEls.forEach(textarea => {
    const rows = textarea.value.split('\n').length
    textarea.rows = Math.min(rows + 3, 6)
    textarea.dataset.controller = "textarea-autogrow"
  })
}

StreamActions.refresh_math_formula = function() {
  const mathFormulaEls = document.querySelectorAll("[data-math-style]")
  mathFormulaEls.forEach(mathFormula => {
    var options = MathJax.getMetricsFor(mathFormula);
    options.display = false;

    console.log(mathFormula)
    MathJax.tex2svgPromise(mathFormula.innerText, options).then(function (node) {
      mathFormula.innerText = ""
      mathFormula.appendChild(node);
    });
  })
}

StreamActions.trigger_edit_row = function() {
  const row_id = this.getAttribute("row_id")
  const row = document.querySelector(`#edit-row-link-${row_id}`)
  row.click()
}

StreamActions.trigger_click = function() {
  const link_id = this.getAttribute("element_id")
  const link = document.querySelector(link_id)
  link.click()
}
